import { render, staticRenderFns } from "./RoomAvailabilityWidget.vue?vue&type=template&id=ad481faa&scoped=true&"
import script from "./RoomAvailabilityWidget.vue?vue&type=script&lang=js&"
export * from "./RoomAvailabilityWidget.vue?vue&type=script&lang=js&"
import style0 from "./RoomAvailabilityWidget.vue?vue&type=style&index=0&id=ad481faa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad481faa",
  null
  
)

export default component.exports